import { ref } from 'vue';
import { GroupTag } from '@/types/v2';

export const availableTags = ref<GroupTag[]>([]);

export const setAvailableTags = (tags: GroupTag[]) => {
  availableTags.value = tags;
}; 